export default {
  name: 'Accordion',
  template: `
<details class="accordion">
  <summary>
    <div>
      <span class="h3">{{ title }}</span>
      <i class="icon-caret-down"></i>
    </div>
  </summary>

  <div class="accordion__content">
    <hr>
    {{ content }}
  </div>
</details>
  `,
  props: { title: String, content: String },
}
